import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { blue20 } from "@churchofjesuschrist/eden-style-constants";
const sizes = {
  standard: "2.5rem",
  jumbo: "3.5rem"
};
const Root = styled.div.withConfig({
  componentId: "sc-1rersa1-0"
})(["width:", ";height:0.25rem;background-color:", ";"], _ref => {
  let {
    size
  } = _ref;
  return sizes[size] ? sizes[size] : sizes.standard;
}, _ref2 => {
  let {
    color = blue20
  } = _ref2;
  return color;
});

const Bar = props => /*#__PURE__*/React.createElement(Root, props);

Bar.propTypes = {
  /** The fill color of the bar */
  color: PropTypes.string,

  /** The width of the bar */
  size: PropTypes.oneOf(["standard", "jumbo"])
};
export default Bar;